import React, { memo } from 'react';
import { Link as NavLink, LinkProps } from 'react-router-dom';

import { useStyles } from './styles';

export interface ILinkProps extends LinkProps {
  label: string;
  disabled?: boolean;
  styleClass?: string;
}

const Link = ({ label, disabled, styleClass, ...rest }: ILinkProps) => {
  const classes = useStyles();
  return (
    <NavLink
      className={`${classes.link} ${disabled ? classes.disabledLink : ''} ${styleClass}`}
      onClick={e => disabled && e.preventDefault()}
      {...rest}
    >
      {label}
    </NavLink>
  );
};

export default memo(Link);
